import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// import Icon from '../Icon';
import { H1, Lead } from '../../style';
import { Brands } from '../../common/constants';

// const Chevron = styled(Icon)`
//   width: 24px;
//   height: 24px;
// `;

const Container = styled.div`
  margin-top: ${(props) => props.theme.whitespace.xl};
  margin-bottom: ${(props) => props.brand === Brands.Wireless ? '0' : props.theme.whitespace.xl};
`;

const FlexContainer = styled.div`
  display: flex;
`;

const Primary = styled(H1)`
  margin-top: 0;
  line-height: 1em;
  ${({ brand, theme }) => brand === Brands.Wireless && theme.type.productsTitle};
`;

const Secondary = styled(Lead)`
  font-size: ${({ brand }) => brand === Brands.Wireless && '16px'};
  margin: 0;
  ${({ brand, theme }) => brand === Brands.Wireless && theme.type.layoutBodyTitle};
  ${({ brand, theme }) =>
    brand === Brands.Wireless &&
    `
     && a {
        font-family: ${theme.type.layoutBodyTitleLink.fontFamily};
        font-size: ${theme.type.layoutBodyTitleLink.fontSize};
        font-weight: ${theme.type.layoutBodyTitleLink.fontWeight};
        line-height: ${theme.type.layoutBodyTitleLink.lineHeight};
      }
  `}
`;

const Title = ({ primary, secondary, brand }) => (
  <Container brand={brand}>
    <FlexContainer>
      <Primary brand={brand}>
        {primary}
      </Primary>
    </FlexContainer>
    {secondary && <Secondary brand={brand}>{secondary}</Secondary>}
  </Container>
);

Title.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  brand: PropTypes.string
};

Title.defaultProps = {
  secondary: null
};

export default Title;
